<template>
  <section
    class="main-layout"
    :class="{'nav-open': isNavOpen}"
  >
    <mobility-navigation v-if="!components" />
    <rent-body v-if="layout !== 'nav-only'" />
    <mobility-footer />
    <full-page-loader />

    <light-box
      :visible="shouldDisplayPopin "
      @close="closeGlobalPopin"
    >
      <global-popin
        v-if="activePopin && !isPopinShown"
        @done="closeGlobalPopin"
      />
    </light-box>
  </section>
</template>

<script>
import isEqual from 'lodash-es/isEqual'
import { mapState, mapGetters } from 'vuex'
import RentBody from './shared/RentBody'
import FullPageLoader from './shared/FullPageLoader'
import LightBox from './shared/LightBox'
import GlobalPopin from './Popins/GlobalPopin'
import store from '../store'
import { pickupBusiness as setLocalStorageBusiness, removeCompletedBookingInfo } from '../utils/setLocalStorage'
import MobilityFooter from './shared/MobilityFooter'
import MobilityNavigation from './shared/nav/MobilityNavigation';

export default {
  store,
  components: {
    RentBody,
    FullPageLoader,
    LightBox,
    GlobalPopin,
    MobilityFooter,
    MobilityNavigation,
  },
  props: {
    layout: {
      type: String,
      default: '',
    },
    components: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      PopinGlobal: true,
      popin: localStorage.getItem('popinGlobal') === null ? 0 : localStorage.getItem('popinGlobal'),
    }
  },
  watch: {
    isGetProfileRequested: {
      immediate: true,
      handler(val) {
        if (!val) {
          return
        }
        this.$store.dispatch('popins/GET_POPINS')
      },
    },
    stickyHeaderActivation: {
      handler: 'showStickyHeader',
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      degradedMode: (state) => state.degradedMode,
      isNavOpen: (state) => state.isNavOpen,
      bookingData: (state) => ({
        pickUp: state.booking.pickUp,
        drop: state.booking.drop,
      }),
      quotationDetails: (state) => state.quotation.details,
      isPopinShown: (state) => state.popins.isPopinShown,
      user: (state) => state.user?.details,
    }),
    ...mapGetters({
      canGetPrices: 'vehicles/canGetPrices',
      canGetAvailability: 'vehicles/canGetAvailability',
      activePopin: 'popins/activePopin',
      shouldDisplayPopin: 'popins/shouldDisplayPopin',
      isGetProfileRequested: 'user/isGetProfileRequested',
      userIsLogged: 'auth/userIsLogged',
    }),
    getPathname() {
      return window.location.pathname
    },
  },
  created() {
    this.analytics()
    this.LEAD_COMPLETED = window.renaultRent.lead
  },
  mounted() {
    this.checkRrf()

    this.bodyHeight();
    this.$store.dispatch('user/GET_USER_PROFILE')
    this.$store.commit('LAYOUT_INITIALIZATION', this.layout)
    this.$store.dispatch('stepping/GET_STEPPING')

    const popin = localStorage.getItem('popinGlobal');
    if (popin === 'true') {
      localStorage.setItem('popinGlobal', true);
      this.PopinGlobal = !!localStorage.getItem('popinGlobal');
    }

    this.checkNewDate()
    if (window.renaultRent.sessions) {
      this.overrideWithPrefillData()
    }
    this.updateStoreFromLocalStorage()
  },
  methods: {
    bodyHeight() {
      const header = document.querySelector('.navigation')
      const headerHeight = header.getBoundingClientRect().height
      const body = document.querySelector('.body');
      body.style.paddingTop = `${headerHeight}px`;
    },
    checkNewDate() {
      const pickDate = new Date(localStorage.getItem('rentPickupDate'))
      const curDate = new Date()
      if (pickDate < curDate) {
        this.$store.commit('booking/SET_PICKUP_DATE', null)
        this.$store.commit('booking/SET_PICKUP_TIME', null)
        this.$store.commit('booking/SET_DROP_DATE', null)
        this.$store.commit('booking/SET_DROP_TIME', null)
        localStorage.removeItem('rentPickupDate')
        localStorage.removeItem('rentPickupTime')
        localStorage.removeItem('rentDropDate')
        localStorage.removeItem('rentDropTime')
        if (!localStorage.getItem('firstLoad') && window.location.pathname === '/devis/options') {
          localStorage.firstLoad = true;
          window.location = '/';
        } else {
          localStorage.removeItem('firstLoad');
        }
      }
    },
    showStickyHeader() {
      const changeAgences = window.location.search === '?changer_agences';
      const changeDate = window.location.search === '?changer_date';
      if (changeAgences || changeDate) {
        this.$store.commit('stepping/SET_HEADER', true)
      }
      if (window.localStorage.rentDropTime) {
        return
      }
      if (window.location.pathname === '/vehicules') {
        this.$store.commit('stepping/SET_HEADER', true)
      }
    },
    analytics() {
      const page = window.location.href
      const pageTitle = document.querySelector('head title')?.text
      const loginStatus = this.isGetProfileRequested ? this.userIsLogged : 'N/A'
      const userId = this.loginStatus === 'N/A' ? 'N/A' : this.user?.email

      if (!window.renaultRent.gtm_ua) {
        return
      }
      const payload = {
        loginStatus,
        page,
        pageTitle,
        userId,
      }
      window.dataLayer.push(payload)
    },
    isBottomNavLinks() {
      return (
        ['quotation-layout', 'forgot-password-layout'].indexOf(
          this.layout,
        ) === -1
      )
    },
    checkRrf() {
      const rrfBusiness = window.renaultRent.business
      if (!rrfBusiness) {
        return
      }
      if (rrfBusiness.id.toString() !== localStorage.getItem('rentPickupBusinessId')) {
        removeCompletedBookingInfo()
      }
      setLocalStorageBusiness(rrfBusiness.id)
    },

    overrideWithPrefillData() {
      // debugger // eslint-disable-line
      const { sessions } = window.renaultRent
      if (typeof sessions !== 'object' || Array.isArray(sessions)) {
        return
      }

      const {
        business,
        returnBusiness,
        departureDate,
        departureHour,
        returnDate,
        returnHour,
        vehicle,
        promoCode,
        kilometers,
      } = sessions

      /* eslint-disable no-unused-expressions */
      const business2 = localStorage.getItem('rentPickupBusinessId')
      const businessRetrun = localStorage.getItem('rentDropBusinessId')
      const pickDate = localStorage.getItem('rentPickupDate')
      const picktime = localStorage.getItem('rentPickupTime')
      const drpDate = localStorage.getItem('rentDropDate')
      const drptime = localStorage.getItem('rentDropTime')
      const vehiculess = localStorage.getItem('rentVehicle')
      const km = localStorage.getItem('additionnalKms')
      const coupon = localStorage.getItem('coupon')

      if (!pickDate) {
        const result = new Date();
        result.setDate(result.getDate() + 7);
        this.$store.commit('booking/SET_PICKUP_DATE', result)
      }

      // Change pickup time if url is different to localstorage
      const { searchParams } = new URL(window.location.href);

      if (searchParams.get('heure_depart') && departureHour && departureHour !== picktime) {
        this.$store.commit('booking/SET_PICKUP_TIME', departureHour)
      }
      if (searchParams.get('heure_retour') && returnHour && returnHour !== drptime) {
        this.$store.commit('booking/SET_DROP_TIME', returnHour)
      }
      if (searchParams.get('modele') && vehicle && vehicle.id !== vehiculess) {
        this.$store.commit('vehicles/SET_SELECTED_VEHICLE', vehicle)
      }

      if (searchParams.get('date_depart') && departureDate && departureDate !== pickDate) {
        this.$store.commit('booking/SET_PICKUP_DATE', departureDate)
      }

      if (searchParams.get('date_retour') && returnDate && returnDate !== drpDate) {
        this.$store.commit('booking/SET_DROP_DATE', returnDate)
      }

      if (searchParams.get('code_rrf') && business && business !== business2) {
        this.$store.commit('booking/SET_PICKUP_BUSINESS', business)
        this.$store.commit('booking/SET_DROP_BUSINESS', business)
      }

      if (searchParams.get('code_rrf_retour') && returnBusiness && returnBusiness !== businessRetrun) {
        this.$store.commit('booking/SET_PICKUP_BUSINESS', returnBusiness)
        this.$store.commit('booking/SET_DROP_BUSINESS', returnBusiness)
      }

      !business2 ? business && this.$store.commit('booking/SET_PICKUP_BUSINESS', business) : null
      !businessRetrun ? returnBusiness && this.$store.commit('booking/SET_DROP_BUSINESS', returnBusiness) : null
      !pickDate ? departureDate && this.$store.commit('booking/SET_PICKUP_DATE', new Date(departureDate)) : null
      !picktime ? departureHour && this.$store.commit('booking/SET_PICKUP_TIME', departureHour) : null
      !drpDate ? returnDate && this.$store.commit('booking/SET_DROP_DATE', new Date(returnDate)) : null
      !drptime ? returnHour && this.$store.commit('booking/SET_DROP_TIME', returnHour) : null
      !vehiculess ? vehicle && this.$store.commit('vehicles/SET_SELECTED_VEHICLE', vehicle) : null
      !coupon ? promoCode && this.$store.commit('quotation/SET_COUPON', promoCode) : null
      !km ? kilometers && this.$store.commit('quotation/SET_KM', kilometers) : null
    },
    updateStoreFromLocalStorage() {
      this.checkForOneWayAvailable()
      this.checkForDegraded()
      if (!this.LEAD_COMPLETED) {
        this.updateBusiness()
        this.updateDates()
        this.updateVehicle()
      }
      this.updateUser()
      this.updateAdditionalDrivers()
      this.updateIsLightSignUp()
      this.updateSignupOrigin()
      this.updatePopinsShownIds()
      this.updateCdw()
      this.updateAdditionalKms()
      this.updateCoupon()
    },
    checkForOneWayAvailable() {
      const oneWay = window.renaultRent.settings.use_oneway === 1
      if (oneWay) {
        return this.$store.dispatch('booking/SET_ONEWAY_STATE', true)
      }
      return this.$store.dispatch('booking/SET_ONEWAY_STATE', false)
    },
    checkForDegraded() {
      const degraded = !window.renaultRent.rrsAvailable
      if (degraded) {
        return this.$store.commit('SET_DEGRADED_MODE_TRUE')
      }
    },
    updateBusiness() {
      const localStorageOneWay = JSON.parse(localStorage.getItem('oneWay'))
      const pickup = JSON.parse(localStorage.getItem('rentPickupBusinessId'))
      let drop = JSON.parse(localStorage.getItem('rentDropBusinessId'))
      if (!pickup) {
        this.$store.commit('booking/SET_BUSINESS_LOCAL_STORAGE_CHECKED_TRUE')
        return
      }
      if (!this.degradedMode) {
        this.$store.commit('booking/SET_ONEWAY', localStorageOneWay)
      }
      if (this.degradedMode || !localStorageOneWay || !drop) {
        drop = pickup
      }
      this.$store.dispatch('booking/GET_BUSINESS_INFO', { pickup, drop })
    },
    updateDates() {
      this.dateTimeCheckLocalStorageFor(
        'rentPickupDate',
        'SET_PICKUP_DATE',
        true,
      )
      if (!this.bookingData.pickUp.date) {
        this.deleteExpiredDateFromLocalStorage('rentPickupTime')
        this.deleteExpiredDateFromLocalStorage('rentDropDate')
        this.deleteExpiredDateFromLocalStorage('rentDropTime')
      }
      this.dateTimeCheckLocalStorageFor(
        'rentPickupTime',
        'SET_PICKUP_TIME',
      )
      if (!this.bookingData.pickUp.time) {
        this.deleteExpiredDateFromLocalStorage('rentDropDate')
        this.deleteExpiredDateFromLocalStorage('rentDropTime')
      }
      this.dateTimeCheckLocalStorageFor(
        'rentDropDate',
        'SET_DROP_DATE',
        true,
      )
      if (!this.bookingData.drop.date) {
        this.deleteExpiredDateFromLocalStorage('rentDropTime')
      }
      this.dateTimeCheckLocalStorageFor(
        'rentDropTime',
        'SET_DROP_TIME',
      )
    },
    dateTimeCheckLocalStorageFor(
      localStorageItem,
      commitName,
      isDate,
    ) {
      let local = localStorage.getItem(localStorageItem)

      if (!local) {
        return
      }
      if (isDate) {
        local = new Date(local)
      }
      if (local === 'null') {
        local = null
      }
      this.$store.commit(`booking/${commitName}`, local)
    },
    dateIsBeforeNow(date) {
      return new Date() > date
    },
    deleteExpiredDateFromLocalStorage(localStorageItem) {
      return localStorage.removeItem(localStorageItem)
    },
    updateVehicle() {
      const localVehicle = localStorage.getItem('rentVehicle')
      if (!localVehicle) {
        return
      }
      this.$store.dispatch('vehicles/GET_VEHICLE_FROM_ID', localVehicle)
    },
    updateUser() {
      const accessToken = localStorage.getItem('accessToken')
      if (!accessToken) {
        return
      }
      this.$store.commit('auth/SET_ACCESS_TOKEN', accessToken)
    },
    updateAdditionalDrivers() {
      const driverIds = localStorage.getItem('additionnalDrivers')
      if (!driverIds || !driverIds.length) {
        return
      }
      driverIds.split(',').forEach((id) => {
        this.$store.dispatch('quotation/ADD_DRIVER_TO_QUOTATION', { id })
      })
    },
    updateIsLightSignUp() {
      const localStorageLightSignup = JSON.parse(localStorage.getItem('isLightSignUp'))
      if (localStorageLightSignup === null) {
        return
      }
      this.$store.commit('stepping/SET_IS_LIGHT_SIGN_UP', localStorageLightSignup)
    },
    updateSignupOrigin() {
      const localStorageSignupOrigin = localStorage.getItem('signupOrigin')
      if (localStorageSignupOrigin === null) {
        return
      }
      this.$store.commit('registration/SET_SIGN_UP_ORIGIN', localStorageSignupOrigin)
    },
    updatePopinsShownIds() {
      const localStorageShownPopinsIds = localStorage.getItem('shownPopinsIds')
      if (localStorageShownPopinsIds) {
        this.$store.commit('popins/SET_LOCALSTORAGE_SHOWN_POPINS_IDS', localStorageShownPopinsIds.split(',').map((s) => parseInt(s, 10)))
      }
    },
    updateCdw() {
      const cdw = localStorage.getItem('cdw')
      if (cdw === null) {
        return
      }
      this.$store.commit('quotation/SET_CDW', JSON.parse(cdw))
    },
    updateCoupon() {
      const coupon = localStorage.getItem('coupon')
      if (coupon === null) {
        return
      }
      this.$store.commit('quotation/SET_COUPON', coupon)
    },
    updateAdditionalKms() {
      const additionnalKms = localStorage.getItem('additionnalKms')
      if (additionnalKms === null) {
        return
      }
      this.$store.commit('quotation/SET_KM', additionnalKms)
    },
    quotationParametersChanged(val, oldVal) {
      return !isEqual(val, oldVal)
    },
    closeGlobalPopin(closeOrigin) {
      this.$store.commit('popins/SET_POPIN_SHOWN', this.activePopin)
      /* eslint-disable-next-line camelcase */
      if (closeOrigin === 'button' && this.activePopin?.redirect_url) {
        window.location = this.activePopin.redirect_url
      }
    },
  },
}
</script>
<style scoped lang="scss">

.main-layout {
  max-width: 100vw;

  @include teq-breakpoint($large) {
    min-height: 100vh;
    position: relative;
  }
}

.rent-footer {
  @include teq-breakpoint($large) {
    bottom: 0;
    position: absolute;
    width: 100%;
  }
}
</style>
